import { Group } from "@radix-ui/react-select";

export const SelectGroup = Group;
